
import request from "../index.js";

export const productlist = (params) =>
    request.get("/payment/stripe/product-list", { params });

export const createCheckout = (params) =>
    request.get(`/payment/stripe/create-checkout`, { params });

export const createinvoice = (params) =>
    request.get(`/payment/xendit/create-invoice`, { params });
    
export const getticketsbyid = (params) =>
    request.get(`/payment/stripe/get-tickets-by-id`, { params });


